import { Formik, Form, ErrorMessage } from 'formik';
import * as yup from 'yup';
import { Button } from 'primereact/button';
import { Calendar } from 'primereact/calendar';
import { DataSource } from 'components/DataSource';
import { Dropdown } from 'primereact/dropdown';
import { InputText } from 'primereact/inputtext';
import { PageRequestError } from 'components/PageRequestError';
import { ProgressSpinner } from 'primereact/progressspinner';
import { Title } from 'components/Title';
import useApp from 'hooks/useApp';

import useEditPage from 'hooks/useEditPage';
const PartnerperformanceEditPage = (props) => {
		const app = useApp();
	// form validation schema
	const validationSchema = yup.object().shape({
		partnershopid: yup.string().required().label("Partnershopid"),
		metricdate: yup.string().required().label("Metricdate"),
		totalbookings: yup.number().nullable().label("Totalbookings"),
		completedbookings: yup.number().nullable().label("Completedbookings"),
		cancelledbookings: yup.number().nullable().label("Cancelledbookings"),
		totalrevenue: yup.number().nullable().label("Totalrevenue"),
		avgcompletiontime: yup.string().nullable().label("Avgcompletiontime"),
		avgrating: yup.number().nullable().label("Avgrating"),
		ontimedeliveryrate: yup.string().nullable().label("Ontimedeliveryrate"),
		customersatisfaction: yup.number().nullable().label("Customersatisfaction"),
		createdat: yup.string().nullable().label("Createdat"),
		updatedat: yup.string().nullable().label("Updatedat")
	});
	// form default values
	const formDefaultValues = {
		partnershopid: '', 
		metricdate: new Date(), 
		totalbookings: "((0))", 
		completedbookings: "((0))", 
		cancelledbookings: "((0))", 
		totalrevenue: "((0))", 
		avgcompletiontime: "((0))", 
		avgrating: "((0))", 
		ontimedeliveryrate: "((0))", 
		customersatisfaction: "((0))", 
		createdat: "(getdate())", 
		updatedat: "(getdate())", 
	}
	//where page logics resides
	const pageController = useEditPage({ props, formDefaultValues, afterSubmit });
	//destructure and grab what we need
	const { formData, handleSubmit, submitForm, pageReady, loading, saving, apiRequestError, inputClassName } = pageController
	//Event raised on form submit success
	function afterSubmit(response){
		app.flashMsg(props.msgTitle, props.msgAfterSave);
		if(app.isDialogOpen()){
			app.closeDialogs(); // if page is open as dialog, close dialog
		}
		else if(props.redirect) {
			app.navigate(`/partnerperformance`);
		}
	}
	// loading form data from api
	if(loading){
		return (
			<div className="p-3 text-center">
				<ProgressSpinner style={{width:'50px', height:'50px'}} />
			</div>
		);
	}
	//display error page 
	if(apiRequestError){
		return (
			<PageRequestError error={apiRequestError} />
		);
	}
	//page is ready when formdata loaded successfully
	if(pageReady){
		return (
<main id="PartnerperformanceEditPage" className="main-page">
    { (props.showHeader) && 
    <section className="page-section mb-3" >
        <div className="container">
            <div className="grid justify-content-between align-items-center">
                { !props.isSubPage && 
                <div className="col-fixed " >
                    <Button onClick={() => app.navigate(-1)} label=""  className="p-button p-button-text " icon="pi pi-arrow-left"  />
                </div>
                }
                <div className="col " >
                    <Title title="Edit Partnerperformance"   titleClass="text-2xl text-primary font-bold" subTitleClass="text-500"      separator={false} />
                </div>
            </div>
        </div>
    </section>
    }
    <section className="page-section " >
        <div className="container">
            <div className="grid ">
                <div className="md:col-9 sm:col-12 comp-grid" >
                    <div >
                        <Formik
                            initialValues={formData}
                            validationSchema={validationSchema} 
                            onSubmit={(values, actions) => {
                            submitForm(values);
                            }
                            }
                            >
                            { (formik) => {
                            return (
                            <Form className={`${!props.isSubPage ? 'card  ' : ''}`}>
                                <div className="grid">
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                Partnershopid *
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <DataSource   apiPath="components_data/partnerid_option_list"  >
                                                    {
                                                    ({ response }) => 
                                                    <>
                                                    <Dropdown  name="partnershopid"     optionLabel="label" optionValue="value" value={formik.values.partnershopid} onChange={formik.handleChange} options={response} label="Partnershopid"  placeholder="Select a value ..."  className={inputClassName(formik?.errors?.partnershopid)}   />
                                                    <ErrorMessage name="partnershopid" component="span" className="p-error" />
                                                    </>
                                                    }
                                                </DataSource>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                Metricdate *
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <Calendar name="metricdate" showButtonBar className={inputClassName(formik?.errors?.metricdate)} dateFormat="yy-mm-dd" value={formik.values.metricdate} onChange={formik.handleChange} showIcon        />
                                                <ErrorMessage name="metricdate" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                Totalbookings 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="totalbookings"  onChange={formik.handleChange}  value={formik.values.totalbookings}   label="Totalbookings" type="number" placeholder="Enter Totalbookings"  min={0}  step="any"    className={inputClassName(formik?.errors?.totalbookings)} />
                                                <ErrorMessage name="totalbookings" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                Completedbookings 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="completedbookings"  onChange={formik.handleChange}  value={formik.values.completedbookings}   label="Completedbookings" type="number" placeholder="Enter Completedbookings"  min={0}  step="any"    className={inputClassName(formik?.errors?.completedbookings)} />
                                                <ErrorMessage name="completedbookings" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                Cancelledbookings 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="cancelledbookings"  onChange={formik.handleChange}  value={formik.values.cancelledbookings}   label="Cancelledbookings" type="number" placeholder="Enter Cancelledbookings"  min={0}  step="any"    className={inputClassName(formik?.errors?.cancelledbookings)} />
                                                <ErrorMessage name="cancelledbookings" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                Totalrevenue 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="totalrevenue"  onChange={formik.handleChange}  value={formik.values.totalrevenue}   label="Totalrevenue" type="number" placeholder="Enter Totalrevenue"  min={0}  step={0.1}    className={inputClassName(formik?.errors?.totalrevenue)} />
                                                <ErrorMessage name="totalrevenue" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                Avgcompletiontime 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <Calendar name="avgcompletiontime" value={formik.values.avgcompletiontime} onChange={formik.handleChange} showButtonBar className={inputClassName(formik?.errors?.avgcompletiontime)}     showTime timeOnly     />
                                                <ErrorMessage name="avgcompletiontime" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                Avgrating 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="avgrating"  onChange={formik.handleChange}  value={formik.values.avgrating}   label="Avgrating" type="number" placeholder="Enter Avgrating"  min={0}  step={0.1}    className={inputClassName(formik?.errors?.avgrating)} />
                                                <ErrorMessage name="avgrating" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                Ontimedeliveryrate 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <Calendar name="ontimedeliveryrate" value={formik.values.ontimedeliveryrate} onChange={formik.handleChange} showButtonBar className={inputClassName(formik?.errors?.ontimedeliveryrate)}     showTime timeOnly     />
                                                <ErrorMessage name="ontimedeliveryrate" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                Customersatisfaction 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="customersatisfaction"  onChange={formik.handleChange}  value={formik.values.customersatisfaction}   label="Customersatisfaction" type="number" placeholder="Enter Customersatisfaction"  min={0}  step={0.1}    className={inputClassName(formik?.errors?.customersatisfaction)} />
                                                <ErrorMessage name="customersatisfaction" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                Createdat 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <Calendar name="createdat" value={formik.values.createdat} onChange={formik.handleChange} showButtonBar showTime dateFormat="yy-mm-dd" hourFormat="24"showIcon className={inputClassName(formik?.errors?.createdat)}        />
                                                <ErrorMessage name="createdat" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                Updatedat 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <Calendar name="updatedat" value={formik.values.updatedat} onChange={formik.handleChange} showButtonBar showTime dateFormat="yy-mm-dd" hourFormat="24"showIcon className={inputClassName(formik?.errors?.updatedat)}        />
                                                <ErrorMessage name="updatedat" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                { props.showFooter && 
                                <div className="text-center my-3">
                                    <Button onClick={(e) => handleSubmit(e, formik)}  type="submit" label="Update" icon="pi pi-send" loading={saving} />
                                </div>
                                }
                            </Form>
                            );
                            }
                            }
                            </Formik>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </main>
		);
	}
}
PartnerperformanceEditPage.defaultProps = {
	primaryKey: 'id',
	pageName: 'partnerperformance',
	apiPath: 'partnerperformance/edit',
	routeName: 'partnerperformanceedit',
	submitButtonLabel: "Update",
	formValidationError: "Form is invalid",
	formValidationMsg: "Please complete the form",
	msgTitle: "Update Record",
	msgAfterSave: "Record updated successfully",
	msgBeforeSave: "",
	showHeader: true,
	showFooter: true,
	redirect: true,
	isSubPage: false
}
export default PartnerperformanceEditPage;
